<div class="dialog-container">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{ "objetivos.solicitar.title" | translate }}</h2>
    </div>

    <div mat-dialog-content class="dialog-content">
        <p class="dialog-description">
            {{ "objetivos.solicitar.description" | translate }}
        </p>

        <form [formGroup]="formSolicitarObjetivo" class="form-container">
            <!-- Título -->
            <mat-form-field appearance="outline" class="w-100-p">
                <mat-label>{{ "objetivos.solicitar.titulo.label" | translate }}</mat-label>
                <input
                    matInput
                    formControlName="titulo"
                    [placeholder]="'objetivos.solicitar.titulo.placeholder' | translate"
                    [maxlength]="maxTitleLength"
                />
                <mat-hint align="end">
                    <span [class.text-danger]="tituloCaracteresRestantes < 20">
                        {{ tituloCaracteresRestantes }} {{ "objetivos.solicitar.titulo.hint" | translate }}
                    </span>
                </mat-hint>
                @if (titulo?.invalid && titulo?.touched) {
                    <mat-error>
                        @if (titulo?.errors?.["required"]) {
                            <span>{{ "objetivos.solicitar.titulo.error.required" | translate }}</span>
                        }
                        @if (titulo?.errors?.["minlength"]) {
                            <span
                                >{{ "objetivos.solicitar.titulo.error.minlength" | translate }} {{ minTitleLength }}
                                {{ "objetivos.caracteres" | translate }}</span
                            >
                        }
                        @if (titulo?.errors?.["maxlength"]) {
                            <span
                                >{{ "objetivos.solicitar.titulo.error.maxlength" | translate }} {{ maxTitleLength }}
                                {{ "objetivos.caracteres" | translate }}</span
                            >
                        }
                    </mat-error>
                }
            </mat-form-field>

            <!-- Descripción -->
            <mat-form-field appearance="outline" class="w-100-p">
                <mat-label>{{ "objetivos.solicitar.descripcion.label" | translate }}</mat-label>
                <textarea
                    matInput
                    formControlName="descripcion"
                    [placeholder]="'objetivos.solicitar.descripcion.placeholder' | translate"
                    rows="4"
                    [maxlength]="maxDescriptionLength"
                >
                </textarea>
                <mat-hint align="end">
                    <span [class.text-danger]="descripcionCaracteresRestantes < 50">
                        {{ descripcionCaracteresRestantes }} {{ "objetivos.solicitar.descripcion.hint" | translate }}
                    </span>
                </mat-hint>
                @if (descripcion?.invalid && descripcion?.touched) {
                    <mat-error>
                        @if (descripcion?.errors?.["required"]) {
                            <span>{{ "objetivos.solicitar.descripcion.error.required" | translate }}</span>
                        }
                        @if (descripcion?.errors?.["maxlength"]) {
                            <span
                                >{{ "objetivos.solicitar.descripcion.error.maxlength" | translate }}
                                {{ maxDescriptionLength }} {{ "objetivos.caracteres" | translate }}</span
                            >
                        }
                    </mat-error>
                }
            </mat-form-field>

            <!-- Fechas y Weight -->
            <div fxLayout="row" fxLayoutGap="16px" class="dates-weight-container">
                <!-- Fecha de Inicio -->
                <mat-form-field appearance="outline" fxFlex="1 1 0">
                    <mat-label>{{ "objetivos.solicitar.fechaInicio.label" | translate }}</mat-label>
                    <input matInput [matDatepicker]="pickerInicio" formControlName="fechaInicio" readonly />
                    <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                    <mat-datepicker #pickerInicio></mat-datepicker>
                    @if (fechaInicio?.invalid && fechaInicio?.touched) {
                        <mat-error>
                            @if (fechaInicio?.errors?.["required"]) {
                                <span>{{ "objetivos.solicitar.fechaInicio.error.required" | translate }}</span>
                            }
                        </mat-error>
                    }
                </mat-form-field>

                <!-- Fecha de Fin -->
                <mat-form-field appearance="outline" fxFlex="1 1 0">
                    <mat-label>{{ "objetivos.solicitar.fechaFin.label" | translate }}</mat-label>
                    <input matInput [matDatepicker]="pickerFin" formControlName="fechaFin" readonly />
                    <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
                    <mat-datepicker #pickerFin></mat-datepicker>
                    @if (fechaFin?.invalid && fechaFin?.touched) {
                        <mat-error>
                            @if (fechaFin?.errors?.["required"]) {
                                <span>{{ "objetivos.solicitar.fechaFin.error.required" | translate }}</span>
                            }
                        </mat-error>
                    }
                </mat-form-field>

                <!-- Weight -->
                <mat-form-field appearance="outline" fxFlex="0 0 120px">
                    <mat-label>{{ "objetivos.solicitar.weight.label" | translate }}</mat-label>
                    <input
                        matInput
                        type="number"
                        formControlName="weight"
                        [min]="minWeight"
                        [max]="maxWeight"
                        step="0.1"
                    />
                    @if (weight?.invalid && weight?.touched) {
                        <mat-error>
                            @if (weight?.errors?.["required"]) {
                                <span>{{ "objetivos.solicitar.weight.error.required" | translate }}</span>
                            }
                            @if (weight?.errors?.["min"]) {
                                <span>{{ "objetivos.solicitar.weight.error.min" | translate }}{{ minWeight }}</span>
                            }
                            @if (weight?.errors?.["max"]) {
                                <span>{{ "objetivos.solicitar.weight.error.max" | translate }}{{ maxWeight }}</span>
                            }
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        </form>
    </div>

    <div mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="onCancel()" class="btn-cancel">
            {{ "objetivos.solicitar.button.cancel" | translate }}
        </button>
        <button
            mat-raised-button
            color="primary"
            (click)="onConfirm()"
            [disabled]="!puedeConfirmar"
            class="btn-confirm"
        >
            {{ "objetivos.solicitar.button.confirm" | translate }}
        </button>
    </div>
</div>
